// @ts-nocheck
import clevertap from "clevertap-web-sdk";
import { memo, useContext, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

// react-slick
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

// icons
import { SvgArrowLeft as ArrowLeft } from "assets/icons/js/SvgArrowLeft";
import { SvgArrowRight as ArrowRight } from "assets/icons/js/SvgArrowRight";
import {
	SvgBlankHeart as BlankHeart,
	SvgBlankHeart,
} from "assets/icons/js/SvgBlankHeart";
import { SvgBreakfast } from "assets/icons/js/SvgBreakfast";
import { SvgFilledHeart as FilledHeart } from "assets/icons/js/SvgFilledHeart";
import { SvgLocation as Location } from "assets/icons/js/SvgLocation";
import { SvgNewHome } from "assets/icons/js/SvgNewHome";
import { SvgPetFriendly } from "assets/icons/js/SvgPetFriendly";
import { SvgRare } from "assets/icons/js/SvgRare";
import { SvgSignatureTag as SignatureTag } from "assets/icons/js/SvgSignatureTag";
import { ReactComponent as SafeIcon } from "assets/100%Safe.svg";

import { SvgCouple } from "assets/icons/js/SvgCouple";
import { SvgFamily } from "assets/icons/js/SvgFamily";
import { SvgPool } from "assets/icons/js/SvgPool";
import { SvgVeg } from "assets/icons/js/SvgVeg";

import SvgWifi from "assets/icons/js/SvgWifi";

// helpers
import addCommas from "helpers/addCommasToNumber";
import { AddingToCollection } from "helpers/addToCollection";
import parseHTML from "helpers/parseHTML";

// context
import { SearchPageDataInterface } from "context/SearchPageData";

// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";
import { useUser } from "customHooks/useUser";

import { UserContext } from "store";

// style
import "./styles.scss";
import { SvgNewhomesDis } from "assets/icons/js/SvgNewhomesDis";
import { SvgStar } from "assets/icons/js/SvgStar";
import { SvgWhiteHeart } from "assets/icons/js/SvgWhiteHeart";
import { SvgTea } from "assets/icons/js/SvgTea";
import { SvgListingSignature } from "assets/icons/js/SvgListingSignature";
import { SvgHiddenGem } from "assets/icons/js/SvgHiddenGem";
import { SvgNextLogo } from "assets/icons/js/SvgNextLogo";
import XSeriesLogo from "assets/x-series.png";
import { ReactComponent as HighTAC } from "assets/HighTAC.svg";
import { ReactComponent as NextSearch } from "assets/next.svg";
export const SearchPageCard = ({
	id,
	title,
	location,
	img,
	numOfNights,
	benefits,
	rating,
	reviews,
	price,
	signature,
	newHome = false,
	xseries,
	discountPrice,
	setShouldShowRemoveModal,
	minRooms,
	type,
	noOfBedrooms,
	capacity,
	saved,
	available,
	minCap,
	inCollection,
	hidePrice = false,
	seoURL = "villa",
	prevLocation = "",
	hideAvail = true,
	newHomeDis,
	distance = 0,
	off = 0,
	next = false,
	checkin,
	checkout,
	NO_OF_BEDROOMS,
	RED_TAPE,
	UNLOCK_MAGIC,
	suitableList,
	HIGH_TAC,
	is_next,
}: any) => {
	// @ts-ignore
	const { setShowLoginPopup, query } = useContext(SearchPageDataInterface);
	const [searchParams, setSearchParams] = useSearchParams();
	const [save, setSave] = useState(inCollection);

	// check if the user exists
	const user = useUser();
	const { state } = useContext(UserContext);
	const { currentUser } = state;

	const { pathname } = useLocation();
	const isSearchPage = pathname === "/search" ? true : false;
	const isHomePage = pathname === "/" ? true : false;

	const width = useMediaQuery();
	const isMobile = width <= 500 ? true : false;

	// settings for image carousel
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		// @ts-ignore
		prevArrow: <ArrowLeft />,
		// @ts-ignore
		nextArrow: <ArrowRight />,
		dotsClass: "button__bar",
		lazyLoad: true,
	};

	const [showMoreRedTape, setShowMoreRedTape] = useState(false);

	const nanCheck = isNaN(rating) === true ? 0 : +rating;
	const new_home_2 = searchParams.get("new_homes") === "true" ? true : false;
	const cardTop = (
		<div className="new__card__img">
			<div className="new__card__img__box">
				<Slider {...settings}>
					{img?.map((value: any, i: any) => {
						return (
							<LazyLoadImage
								alt={
									window.location.pathname.includes("villas/")
										? `${parseHTML(title)}, villa in ${
												query.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2]
										  }`
										: parseHTML(title)
								}
								src={value}
								onClick={() => {
									clevertap.event.push("featured_card_website", {
										from: prevLocation,
										listing_name: `${title}`,
										listing_url: `${seoURL + "-"}${id}`,
									});
									if (discountPrice) {
										clevertap.event.push("rare_price_tag", {
											from: prevLocation,
											listing_name: `${title}`,
											listing_url: `${seoURL + "-"}${id}`,
										});
									}
								}}
								key={i}
								effect="blur"
							/>
						);
					})}
				</Slider>
			</div>
		</div>
	);

	const cardBottom = (
		<div className="bottom__container">
			<div className="title__container">
				<span className="title">
					<h2>{parseHTML(title)}</h2>
					<span
						onClick={(e) => {
							e.preventDefault();
							if (!user) {
								setShowLoginPopup(true);
							}
							if (user) {
								setSave((prev) => !prev);
								AddingToCollection(id, save);
							}
						}}
						style={{ backgroundColor: save ? "#FA4B4B" : "#DDDDDD" }}
						className={`add__to__collection ${
							save ? "collection__active" : "not_active"
						}`}
					>
						<SvgWhiteHeart />
					</span>
				</span>
			</div>
			<div className="location">
				<p>{location}</p>
				{distance ? <span className="distance">{distance}</span> : null}
			</div>
			<div className="detail__container">
				<div className="detail__container__details">
					<span>
						<p>
							{suitableList[84]
								? "Luxury Apartment"
								: type === "Separate Villas"
								? `${noOfBedrooms} Villas`
								: type !== "Separate Villas"
								? type
								: "2 Villas"}
						</p>
					</span>
					<span>
						{minCap && minCap * minRooms !== capacity
							? `${minCap * minRooms} -`
							: ""}{" "}
						{capacity} guests
					</span>
					<span>
						<p>
							{type === "Separate Villas"
								? `${NO_OF_BEDROOMS} Bedroom (per villa)`
								: `${noOfBedrooms} Bedroom`}
						</p>
					</span>
				</div>
				<div className="detail__container__high-tac">
					{currentUser?.isTravelAgent && HIGH_TAC && <HighTAC />}
				</div>
			</div>
			<div className="amen__list">
				{(newHome || new_home_2) && (
					<span className="new__home">
						New launch<strong>&#x2022;</strong>
					</span>
				)}
				{benefits?.includes("Breakfast Included In Tariff") && (
					<span>
						<SvgTea />
						Breakfast included<strong>&#x2022;</strong>
					</span>
				)}
				<div className="last__amen">
					{benefits?.includes("Swimming Pool") && (
						<div data-title="pool">
							<SvgPool />
						</div>
					)}
					{benefits?.includes("Veg Only") && (
						<div data-title="veg only">
							<SvgVeg />
						</div>
					)}
					{benefits?.includes("Pet Friendly") && (
						<div data-title="pet friendly">
							<SvgPetFriendly />
						</div>
					)}
					{benefits?.includes("Couple") && (
						<div data-title="couple">
							<SvgCouple />
						</div>
					)}
					{benefits?.includes("Single Family") && (
						<div data-title="single family">
							<SvgFamily />
						</div>
					)}
					{(benefits?.includes("WiFi Broadband") ||
						benefits?.includes("WiFi Dongle") ||
						benefits?.includes("WiFi Fibre Or WiFi Cable")) && (
						<div data-title="wifi">
							<SvgWifi />
						</div>
					)}
					{benefits?.includes("100% Safe To Travel") && (
						<SafeIcon
							style={{
								width: 100,
							}}
						/>
					)}
				</div>
			</div>
			{/* <div className="safe-wrapper">

			</div> */}
			<div className="tag__container">
				<div className="left__icon">
					{signature ? <SvgListingSignature /> : null}
					{xseries ? (
						<img
							className="saffronstays-xseries"
							src={XSeriesLogo}
							alt="saffronstays xseries"
							style={{
								height: 29,
								marginLeft: -6,
							}}
						/>
					) : null}
					{is_next ? <NextSearch style={{
							width:"60px"
						}} /> : null}
					{id === "sPvqxLHq1ekTHixf" && (
						<div className="hidden__gem" style={{ marginLeft: "auto" }}>
							<SvgHiddenGem />
							<p>Hidden gem</p>
						</div>
					)}
					{/* <span className="next__icon">{next ? <SvgNextLogo /> : null}</span> */}
					{/* <div className="new__card__avail__detail">
						{!hideAvail &&
							(pathname === "/search" ||
								pathname.split("/")[1] === "collection" ||
								pathname.split("/")[1] === "villas" ||
								pathname === "/") && (
								<div className="icon-avail">
									{available === 1 ? (
										<span className="avail">Available</span>
									) : available === 2 ? (
										<span className="avail">Available today</span>
									) : null}
								</div>
							)}
					</div> */}
				</div>

				<div className="right__icon">
					{!newHome &&
					discountPrice &&
					discountPrice - price > 5000 &&
					(available === 1 || available === 2) ? (
						// <div className="icon__rare">
						// 	<span>Rare price</span>
						// </div>
						<></>
					) : null}
				</div>
			</div>

			<div className="price__container">
				{discountPrice &&
				price !== discountPrice &&
				(available === 1 || available === 2) &&
				UNLOCK_MAGIC === "N" ? (
					<span className="discount__price">
						₹ {addCommas(discountPrice)}
						<hr />
					</span>
				) : null}
				<div className="bottom__price">
					{rating ? (
						<div className="rating">
							<SvgStar />
							<span>
								<p>{rating}</p>({reviews})
							</span>
							{rating >= 4.8 && <div className="wonderful">Exceptional</div>}
							{rating >= 4.5 && rating < 4.8 && (
								<div className="wonderful">Superb</div>
							)}
							{rating >= 4.2 && rating < 4.5 && (
								<div className="wonderful">Fabulous</div>
							)}
							{rating >= 4 && rating < 4.2 && (
								<div className="wonderful">Very good</div>
							)}
						</div>
					) : (
						<div className="hidden__gem">
							<SvgHiddenGem />
							<p>Hidden gem</p>
						</div>
					)}
					{UNLOCK_MAGIC && UNLOCK_MAGIC === "Y" ? (
						<div className="unlock-magic-btn">
							{/* <button>Reserve Now</button> */}
						</div>
					) : (
						<div
							className="price"
							style={{
								flexDirection: "column",
								rowGap: 0,
								justifyContent: "flex-end",
								alignItems: "flex-end",
							}}
						>
							{available === 1 || available === 2 ? (
								<span className="price__per">
									<h4
										style={{
											color: xseries && "#B49F6B",
										}}
									>
										₹ {addCommas(price)} <p>+ GST</p>
									</h4>
									{pathname === "/search" ||
									pathname.split("/")[1] === "villas" ? (
										// <p className="for__nights"> (for {numOfNights} nights)</p>
										<p className="for__nights"> (per night) </p>
									) : (
										""
									)}
								</span>
							) : (
								<span className="sold__out">Sold Out</span>
							)}
							{off ? <p>{off}</p> : null}

							<p style={{ fontSize: 12, color: "#555" }}>
								{type !== "Separate Rooms" &&
									noOfBedrooms > 1 &&
									`(${(price / noOfBedrooms)?.toLocaleString("en-IN", {
										currency: "INR",
										style: "currency",
									})} x ${noOfBedrooms} Rooms)`}
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);

	return (
		<div className="search_card_wrapper">
			<a
				className={`search__card__container ${
					xseries && "xseries-card-wrapper"
				}`}
				href={`/view/${seoURL + "-"}${id}?adults=${
					query?.get("guests") || ""
				}&children=${query?.get("children") || ""}&pets=${
					query?.get("pets") || ""
				}&infants=${query?.get("infants") || ""}&rooms=${
					Math.min(query?.get("rooms"), noOfBedrooms) || ""
				}
	&checkin=${
		query?.get("checkin") ? query.get("checkin") || checkin : ""
	}&checkout=${
					query?.get("checkout") ? query.get("checkout") || checkout : ""
				}`}
				target={width >= 800 ? "_blank" : ""}
				rel={width >= 800 ? "noreferrer" : ""}
			>
				{cardTop}
				{cardBottom}
			</a>
			{RED_TAPE && (
				<div className={`red-tape ${xseries && "red-tape-xseries"}`}>
					{RED_TAPE.length > 250 ? (
						<>
							{RED_TAPE?.slice(0, showMoreRedTape ? RED_TAPE.length : 250)}
							<button
								onClick={(e) => {
									e.stopPropagation();
									setShowMoreRedTape(!showMoreRedTape);
								}}
							>
								{!showMoreRedTape && "...Read More"}
							</button>
						</>
					) : (
						RED_TAPE
					)}
				</div>
			)}
		</div>
	);
};
